function playVideo(id) {
    const videoElement = document.getElementById(id);
    if (videoElement != null) {
      if (videoElement.paused) {
        videoElement.muted = false;
        videoElement.play();
      }else {
        videoElement.pause();
      }
    }
  }

